import React from 'react';
import { Invoice } from '../types';
import { FormattedDate, useIntl, FormattedMessage, FormattedNumber } from 'components/i18n';
import Tag from '@atlaskit/tag';
import { status } from '../messages';
import { css, jsx } from '@emotion/react';
import { DateTime } from 'luxon';
import { Cell } from '../../../components/table';
import _ from 'lodash';
import Tooltip from '@atlaskit/tooltip';

const SaleStatus = React.memo(({invoice}: {invoice?: Invoice}) => {
  const intl = useIntl();
  const text = intl.formatMessage(status[invoice?.status!]);
  // if(sale && sale.amountDue && sale.amountDue !== 0) {
  //   text  = `${text} ${intl.formatNumber(sale.amountDue, {currency: 'EUR', style: 'currency'})}`
  // }
  const dueDatePast =  invoice && invoice.dueDate && DateTime.fromISO(invoice.dueDate).startOf('day') <= DateTime.local().startOf('day')
  const unpaidColor = dueDatePast? 'redLight': 'yellowLight';

  const tag =  <Tag text={text} color={invoice?.status === 'unpaid'? unpaidColor  : 'standard'}  isRemovable={false}/>
  let tooltipContent;
  if(invoice?.status==='paid' || invoice?.status==='partiallypaid') {
    tooltipContent = (invoice?.paymentList || []).map(payment => <div><FormattedNumber value={payment.amount} style="currency" currency="EUR"/>{' '}<FormattedMessage id="common.on" defaultMessage="on"/>{' '}<FormattedDate value={payment.date}/></div>);
    if(invoice?.status === 'partiallypaid') {
      tooltipContent = <>
        {tooltipContent}
        <div css={css`margin-top: 2rem;`}>
          <FormattedMessage id="sale.SaleStatus.dueAmount" defaultMessage={"Amount due: {amount}"} values={{amount: intl.formatNumber(invoice?.amountDue || 0, {style: 'currency', currency: 'EUR'})}}/>
        </div>
      </>
    }
  } else {
    tooltipContent = <FormattedMessage id="sale.SaleStatus.dueAt" defaultMessage={"Due at {date}"} values={{date: intl.formatDate(invoice?.dueDate)}}/>
  }

  return  <Tooltip delay={0} content={tooltipContent}>
    <div>{tag}</div>
  </Tooltip>;
});

export default SaleStatus;
